// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBM_Plex_Mono_0cdd3d', '__IBM_Plex_Mono_Fallback_0cdd3d'","fontStyle":"normal"},"className":"__className_0cdd3d","variable":"__variable_0cdd3d"};